import { Component, Input } from '@angular/core';
import { ArgyleIncomeStream } from '../models/argyle';

@Component({
  selector: 'app-income-ver-paystub-card',
  templateUrl: './income-ver-paystub-card.component.html',
  styleUrls: ['./income-ver-paystub-card.component.less']
})
export class IncomeVerPaystubCardComponent {
  @Input() incomeData : ArgyleIncomeStream;
}
